module.exports = __webpack_public_path__ + "static/tusas-mmu-yeni-a8a1020c57eef4c005dccdbe3c5619de.png";